export default "__VITE_ASSET__CTd50TyP__"